import { setHeaderTabs, setDropDownTabs } from "src/slices/AvToolbar";
import store from "src/store";

// Function for add whiteboard and document tab
export const manageTabs = (tabName, type, currentTab) => {
  const state = store.getState();
  const { headerTabs, dropDownTabs } = state.avToolbar;
  if (headerTabs?.length >= 2) {
    const oldTab = headerTabs[headerTabs?.length - 1];
    const newHeaderTabs = headerTabs.slice(0, headerTabs?.length - 1);
    newHeaderTabs.push(currentTab);

    newHeaderTabs.sort((a, b) => {
      const dateA: any = new Date(a.lastActiveTime);
      const dateB: any = new Date(b.lastActiveTime);
      return dateB - dateA;
    });
    const currentDropdown = dropDownTabs.filter((t) => t.name !== tabName);
    const newDropDownTabs = [...currentDropdown, oldTab];
    newDropDownTabs.sort((a, b) => {
      const dateA: any = new Date(a.lastActiveTime);
      const dateB: any = new Date(b.lastActiveTime);
      return dateB - dateA;
    });
    store.dispatch(setHeaderTabs(newHeaderTabs));
    store.dispatch(setDropDownTabs(newDropDownTabs));
  } else {
    const newHeader = [...headerTabs, currentTab];
    newHeader.sort((a, b) => {
      const dateA: any = new Date(a.lastActiveTime);
      const dateB: any = new Date(b.lastActiveTime);
      return dateB - dateA;
    });
    const currentDropdown = dropDownTabs.filter((t) => t.name !== tabName);
    currentDropdown.sort((a, b) => {
      const dateA: any = new Date(a.lastActiveTime);
      const dateB: any = new Date(b.lastActiveTime);
      return dateB - dateA;
    });
    store.dispatch(setHeaderTabs(newHeader));
    store.dispatch(setDropDownTabs(currentDropdown));
  }
};

// Function for handle machine tab (supports multiple machine tabs)
export const handleTabMachine = (newTab) => {
  const state = store.getState();
  const { headerTabs, dropDownTabs } = state.avToolbar;
  // Remove only the tab for the same device if it already exists
  const filteredHeader = headerTabs.filter(
    (t) => !(t.type === "Machine" && t.deviceId === newTab.deviceId)
  );
  const filteredDropDown = dropDownTabs.filter(
    (t) => !(t.type === "Machine" && t.deviceId === newTab.deviceId)
  );
  if (filteredHeader?.length >= 2) {
    const oldTab = filteredHeader[filteredHeader?.length - 1];
    const newHeaderTabs = filteredHeader.slice(0, filteredHeader?.length - 1);
    newHeaderTabs.push(newTab);
    newHeaderTabs.sort((a, b) => {
      const dateA: any = new Date(a.lastActiveTime);
      const dateB: any = new Date(b.lastActiveTime);
      return dateB - dateA;
    });
    const newnDropDownTabs = [...filteredDropDown, oldTab];
    newnDropDownTabs.sort((a, b) => {
      const dateA: any = new Date(a.lastActiveTime);
      const dateB: any = new Date(b.lastActiveTime);
      return dateB - dateA;
    });
    store.dispatch(setHeaderTabs(newHeaderTabs));
    store.dispatch(setDropDownTabs(newnDropDownTabs));
  } else {
    const newHeaderTab = [...filteredHeader, newTab];
    newHeaderTab.sort((a, b) => {
      const dateA: any = new Date(a.lastActiveTime);
      const dateB: any = new Date(b.lastActiveTime);
      return dateB - dateA;
    });
    store.dispatch(setHeaderTabs(newHeaderTab));
    store.dispatch(setDropDownTabs(filteredDropDown));
  }
};

// Function for remove unaccess machine tab (supports targeting specific machine)
export const handleCloseMachineTab = (deviceId?: string) => {
  const state = store.getState();
  const { headerTabs, dropDownTabs } = state.avToolbar;
  let newHeader;
  let newDropDown;
  if (deviceId) {
    // Build machine name to also match tabs without deviceId (backward compat)
    const machineName = findMachineName(deviceId);
    const expectedTabName = machineName ? "Machine (" + machineName + ")" : "";
    // Remove tab matching by deviceId OR by name
    const isTargetTab = (t) =>
      t.type === "Machine" &&
      (t.deviceId === deviceId || (!t.deviceId && expectedTabName && t.name === expectedTabName));
    newHeader = headerTabs.filter((t) => !isTargetTab(t));
    newDropDown = dropDownTabs.filter((t) => !isTargetTab(t));
  } else {
    // Fallback: remove all machine tabs
    newHeader = headerTabs.filter((t) => t.type !== "Machine");
    newDropDown = dropDownTabs.filter((t) => t.type !== "Machine");
  }
  store.dispatch(setHeaderTabs(newHeader));
  store.dispatch(setDropDownTabs(newDropDown));
};

export const manageTabsUserSide = (tabList = []) => {
  const state = store.getState();
  const { activeMachine } = state.persistStore;
  const { is360Accessed } = state.VIEW360;

  // Build machine tabs for ALL active machines
  const machineTabs = [];
  if (!is360Accessed) {
    activeMachine.forEach((machine) => {
      const machineName = findMachineName(machine?.deviceId);
      if (machineName !== "") {
        machineTabs.push({
          type: "Machine",
          name: "Machine (" + machineName + ")",
          active: false,
          lastActiveTime: machine?.lastActiveTime,
          documentId: "",
          deviceId: machine?.deviceId,
        });
      }
    });
  }

  const combineTab = [...machineTabs, ...tabList];
  combineTab.sort((a, b) => {
    const dateA: any = new Date(a.lastActiveTime);
    const dateB: any = new Date(b.lastActiveTime);
    return dateB - dateA;
  });
  if (combineTab?.length <= 2) {
    store.dispatch(setHeaderTabs(combineTab));
    store.dispatch(setDropDownTabs([]));
  } else {
    const newHeaderTabs = combineTab.slice(0, 2);
    const newDropDownTabs = combineTab.slice(2);
    store.dispatch(setHeaderTabs(newHeaderTabs));
    store.dispatch(setDropDownTabs(newDropDownTabs));
  }
};

export const findMachineName = (id) => {
  const state = store.getState();
  const { allServices } = state.resourceAllocation;
    const item = allServices.find(item => item.id === id);
  return item ? item.name : "";
};

export const updateTimerInYjs = (
  ymapPreference,
  duration,
  timerSeconds,
  timerIsActive,
  showSetTimer,
  stopWatchIsActive,
  stopwatchSeconds,
) => {
  const currentTime = new Date();
  const timerDetails = {
    timerIsActive: timerIsActive,
    timerDuration: duration,
    timerSeconds: timerSeconds,
    timerSetTime: currentTime.toString(),
    stopWatchIsActive: stopWatchIsActive,
    showSetTimer: showSetTimer,
    stopWatchHours: 0,
    stopWatchMinutes: 0,
    stopWatchSeconds: stopwatchSeconds,
    endsInHour: 0,
    endsInMinutes: 0,
  };
  ymapPreference.set("timer", timerDetails);
};

export const chipColor = (chipName) => {
  if (chipName === "mounting" || chipName === "unmounting") {
        return ({
            color: '#FF9900',
            bgColor: '#FFF7CC'
        });
  } else if (chipName === "mounted") {
        return ({
            color: '#11BD60',
            bgColor: '#DDFFDE'
        });
  } else {
        return ({
            color: '#0062FD',
            bgColor: '#DDEFFF'
        });
  }
};
